<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Group Questions">
      <div class="row">
        <div class="col-md-6 form-group">
          Parent Topic
          <b-form-select v-model="parentTopic" @change="getTopics()" required>
            <option
              v-for="(parentTopic, index) in parentTopics"
              :key="index"
              :value="parentTopic.id"
            >
              {{ parentTopic.name }}
            </option>
          </b-form-select>
          <div v-if="parentTopicEmpty" style="color: red">
            Parent topic is required
          </div>
        </div>

        <div class="col-md-6 form-group" v-if="parentTopic != ''">
          Topic
          <b-form-select v-model="topic" @change="getSubtopics()" required>
            <option
              v-for="(topic, index) in topics"
              :key="index"
              :value="topic.id"
            >
              {{ topic.name }}
            </option>
            ></b-form-select
          >
          <div v-if="topicEmpty" style="color: red">Topic is required</div>
        </div>

        <div class="col-md-6 form-group" v-if="topic != ''">
          Sub Topic
          <b-form-select
            v-model="subtopic"
            @change="subtopicEmpty = false"
            required
          >
            <option
              v-for="(subtopic, index) in subtopics"
              :key="index"
              :value="subtopic.id"
            >
              {{ subtopic.name }}
            </option>
          </b-form-select>
          <div v-if="subtopicEmpty" style="color: red">
            Subtopic is required
          </div>
        </div>

        <div class="col-md-6 form-group" v-if="subtopic != ''">
          Question Image
          <b-form-file
            type="file"
            class="form-control"
            v-model="questionImage"
            @change="questionImageUpload"
          ></b-form-file>
        </div>

        <div class="col-md-12 form-group" v-if="subtopic != ''">
          Question
          <vue-editor
            :config="config"
            v-model="question"
            @focus="questionEmpty = false"
            required
          />
          <!-- <ckeditor
            :config="config"
            v-model="question"
            @focus="questionEmpty = false"
            required
          ></ckeditor> -->
          <div v-if="questionEmpty" style="color: red">
            Question is required
          </div>
        </div>
      </div>

      <!-- row 2 -->
      <div class="row" v-for="(qstn, index1) in sub" :key="index1">
        <hr
          style="width: 100%; color: gray; background-color: gray; height: 1px"
          v-if="question != ''"
        />
        <div class="col-md-12" v-if="question != '' && index1 != 0">
          <b-button
            variant="danger"
            class="float-right"
            @click="removeSubquestion(index1)"
            ><i class="fas fa-times"></i
          ></b-button>
        </div>
        <div class="col-md-6 form-group" v-if="question != ''">
          Group Question Type
          <b-form-select
            class="form-control"
            v-model="sub[index1].type"
            @change="subTypeEmpty = false"
          >
            <option value="Fillups">Fillups</option>
            <option value="MCQ">MCQ</option>
          </b-form-select>
          <div v-if="subTypeEmpty && sub[index1].type == ''" style="color: red">
            Group question type is required
          </div>
        </div>

        <!-- Fillups -->

        <div class="col-md-6 form-group" v-if="sub[index1].type != ''">
          Sub Question Image
          <b-form-file
            type="file"
            class="form-control"
            v-model="sub[index1].subquestionImage"
            @change="subquestionImageUpload(index1, $event)"
          ></b-form-file>
        </div>

        <div class="col-md-12 form-group" v-if="sub[index1].type != ''">
          Sub Question
          <vue-editor
            :config="config"
            v-model="sub[index1].subQstn"
            @focus="subQstnEmpty = false"
            required
          />
          <!-- <ckeditor
            :config="config"
            v-model="sub[index1].subQstn"
            @focus="subQstnEmpty = false"
            required
          ></ckeditor> -->
          <div
            v-if="subQstnEmpty && sub[index1].subQstn == ''"
            style="color: red"
          >
            Subquestion is required
          </div>
        </div>

        <div
          class="col-md-6 form-group"
          v-if="sub[index1].type == 'MCQ' && sub[index1].subQstn"
        >
          Options 1
          <input
            class="form-control"
            placeholder="Enter an option"
            v-model="sub[index1].option1"
            @focus="option1Empty = false"
          />
          <div
            v-if="option1Empty && sub[index1].option1 == ''"
            style="color: red"
          >
            Option 1 is required
          </div>
        </div>
        <div
          class="col-md-6 form-group"
          v-if="sub[index1].type == 'MCQ' && sub[index1].subQstn"
        >
          Options 2
          <input
            class="form-control"
            placeholder="Enter an option"
            v-model="sub[index1].option2"
            @focus="option2Empty = false"
          />
          <div
            v-if="option2Empty && sub[index1].option2 == ''"
            style="color: red"
          >
            Option 2 is required
          </div>
        </div>
        <div
          class="col-md-6 form-group"
          v-if="sub[index1].type == 'MCQ' && sub[index1].subQstn"
        >
          Options 3
          <input
            class="form-control"
            placeholder="Enter an option"
            v-model="sub[index1].option3"
          />
        </div>
        <div
          class="col-md-6 form-group"
          v-if="sub[index1].type == 'MCQ' && sub[index1].subQstn"
        >
          Options 4
          <input
            class="form-control"
            placeholder="Enter an option"
            v-model="sub[index1].option4"
          />
        </div>
        <div
          class="col-md-6 form-group"
          v-if="sub[index1].type == 'MCQ' && sub[index1].subQstn"
        >
          Options 5
          <input
            class="form-control"
            placeholder="Enter an option"
            v-model="sub[index1].option5"
          />
        </div>

        <div
          class="col-md-6 form-group"
          v-if="sub[index1].type == 'Fillups' && sub[index1].subQstn"
        >
          Correct Answer
          <input
            class="form-control"
            v-model="sub[index1].correctAnswer"
            @focus="correctAnswerEmpty = false"
          />
          <div
            v-if="correctAnswerEmpty && sub[index1].correctAnswer == ''"
            style="color: red"
          >
            Correct answer is required
          </div>
        </div>

        <div
          class="col-md-6 form-group"
          v-if="sub[index1].type == 'MCQ' && sub[index1].subQstn"
        >
          Correct Option
          <b-form-select
            class="form-control"
            v-model="sub[index1].correctAnswer"
            @change="correctAnswerEmpty = false"
          >
            <option
              v-if="sub[index1].option1 != ''"
              :value="sub[index1].option1"
            >
              1
            </option>
            <option
              v-if="sub[index1].option2 != ''"
              :value="sub[index1].option2"
            >
              2
            </option>
            <option
              v-if="sub[index1].option3 != ''"
              :value="sub[index1].option3"
            >
              3
            </option>
            <option
              v-if="sub[index1].option4 != ''"
              :value="sub[index1].option4"
            >
              4
            </option>
            <option
              v-if="sub[index1].option5 != ''"
              :value="sub[index1].option5"
            >
              5
            </option>
          </b-form-select>
          <div
            v-if="correctAnswerEmpty && sub[index1].correctAnswer == ''"
            style="color: red"
          >
            Correct option is required
          </div>
        </div>

        <div
          class="row m-0"
          style="width: 100%"
          v-for="(soln, index) in sub[index1].moreSolution"
          :key="index"
        >
          <div
            class="col-md-6 form-group"
            v-if="sub[index1].correctAnswer != ''"
          >
            Solution Type
            <b-form-select
              class="form-control"
              v-model="sub[index1].moreSolution[index].solutionType"
              @change="solutionTypeEmpty = false"
            >
              <option value="video">Video</option>
              <option value="description">Description</option>
            </b-form-select>
            <div
              v-if="
                solutionTypeEmpty &&
                  sub[index1].moreSolution[index].solutionType == ''
              "
              style="color: red"
            >
              Solution type is required
            </div>
          </div>

          <div
            class="col-md-5 form-group"
            v-if="
              sub[index1].moreSolution[index].solutionType == 'video' &&
                sub[index1].correctAnswer != ''
            "
          >
            Video Name
            <input
              class="form-control"
              v-model="sub[index1].moreSolution[index].videoName"
              @focus="solutionNameEmpty = false"
            />
            <div
              v-if="
                solutionNameEmpty &&
                  sub[index1].moreSolution[index].videoName == ''
              "
              style="color: red"
            >
              Video name is required
            </div>
          </div>

          <div
            class="col-md-5 form-group"
            v-if="
              sub[index1].moreSolution[index].solutionType == 'description' &&
                sub[index1].correctAnswer != ''
            "
          >
            Solution Image
            <b-form-file
              type="file"
              class="form-control"
              v-model="sub[index1].moreSolution[index].solutionImage"
              @change="solutionImageUpload(index1, index, $event)"
            />
          </div>

          <div
            class="col-md-1 form-group"
            v-if="
              sub[index1].moreSolution[index].solutionType != '' &&
                sub[index1].correctAnswer != ''
            "
          >
            <b-button
              variant="danger"
              class="mt-4"
              @click="removeSolution(index1, index)"
              ><i class="fas fa-trash"></i
            ></b-button>
          </div>

          <div
            class="col-md-12 form-group"
            v-if="
              sub[index1].moreSolution[index].solutionType == 'video' &&
                sub[index1].moreSolution[index].solutionType != '' &&
                sub[index1].correctAnswer != ''
            "
          >
            Solution URL
            <input
              class="form-control"
              placeholder="Enter Youtube URL"
              v-model="sub[index1].moreSolution[index].solutionURL"
              @focus="
                (solutionURLEmpty = false), (solutionURLFormatInvalid = false)
              "
            />
            <div
              v-if="
                solutionURLEmpty &&
                  sub[index1].moreSolution[index].solutionURL == ''
              "
              style="color: red"
            >
              Solution URL is required
            </div>
            <div
              v-if="
                solutionURLFormatInvalid &&
                  sub[index1].moreSolution[index].solutionURL != '' &&
                  !sub[index1].moreSolution[index].solutionURL.match(
                    /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
                  )
              "
              style="color: red"
            >
              Youtube URL format is invalid
            </div>
          </div>

          <div
            class="col-md-12 form-group"
            v-if="
              sub[index1].moreSolution[index].solutionType == 'description' &&
                sub[index1].moreSolution[index].solutionType != '' &&
                sub[index1].correctAnswer != ''
            "
          >
            Solution
            <vue-editor
              :config="config"
              v-model="sub[index1].moreSolution[index].solutionDescription"
              @focus="solutionDescriptionEmpty = false"
            />
            <!-- <ckeditor
              :config="config"
              v-model="sub[index1].moreSolution[index].solutionDescription"
              @focus="solutionDescriptionEmpty = false"
            ></ckeditor> -->
            <div
              v-if="
                solutionDescriptionEmpty &&
                  sub[index1].moreSolution[index].solutionDescription == ''
              "
              style="color: red"
            >
              Solution description is required
            </div>
          </div>
        </div>
        <div
          class="text-right col-md-12 form-group"
          v-if="sub[index1].correctAnswer != ''"
        >
          <b-button variant="success" @click="appendMoreSolution(index1)"
            >Add Solution</b-button
          >
        </div>
      </div>
      <div class="text-right col-md-12 form-group p-0" v-if="buttonEnable()">
        <b-button variant="success" @click="appendMoreSubQuestions()"
          >Add Sub Questions</b-button
        >
      </div>
      <div
        class="text-center form-group"
        v-if="sub[sub.length - 1].correctAnswer"
      >
        <b-button variant="success" @click="addGroupQuestion()" type="submit"
          >Save</b-button
        >
      </div>
      <!-- Loader -->
      <b-overlay
        :show="loader"
        no-wrap
        blur="2px"
        opacity="0.60"
        class="position-fixed"
      >
        <template #overlay>
          <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
        </template>
      </b-overlay>
    </base-block>
    <br />
  </div>
</template>
<script>
import axios from "axios";
export default {
  mounted() {
    this.getParentTopics();
  },
  methods: {
    removeSubquestion(index1) {
      this.sub.splice(index1, 1);
    },

    removeSolution(index1, index) {
      this.sub[index1].moreSolution.splice(index, 1);
    },

    questionImageUpload(event) {
      this.questionImage = event.target.files[0];
    },

    subquestionImageUpload(index1, event) {
      this.sub[index1].subquestionImage = event.target.files[0];
    },

    solutionImageUpload(index1, index, event) {
      this.sub[index1].moreSolution[index].solutionImage =
        event.target.files[0];
    },

    async addGroupQuestion() {
      if (this.parentTopic == "") {
        this.parentTopicEmpty = true;
        return;
      }

      if (this.topic == "") {
        this.topicEmpty = true;
        return;
      }

      if (this.subtopic == "") {
        this.subtopicEmpty = true;
        return;
      }

      if (this.question == "") {
        this.questionEmpty = true;
        return;
      }

      for (var x = 0; x < this.sub.length; x++) {
        if (this.sub[x].type == "") {
          this.subTypeEmpty = true;
          return;
        }

        if (this.sub[x].subQstn == "") {
          this.subQstnEmpty = true;
          return;
        }

        if (this.sub[x].type == "MCQ") {
          if (this.sub[x].option1 == "") {
            this.option1Empty = true;
            return;
          }

          if (this.sub[x].option2 == "") {
            this.option2Empty = true;
            return;
          }
        }

        if (this.sub[x].correctAnswer == "") {
          this.correctAnswerEmpty = true;
          return;
        }

        if (this.sub[x].moreSolution.length > 0) {
          let regex = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
          for (var z = 0; z < this.sub[x].moreSolution.length; z++) {
            if (this.sub[x].moreSolution[z].solutionType == "") {
              this.solutionTypeEmpty = true;
              return;
            }
            if (this.sub[x].moreSolution[z].solutionType == "video") {
              if (this.sub[x].moreSolution[z].solutionURL == "") {
                this.solutionURLEmpty = true;
                return;
              }

              if (!this.sub[x].moreSolution[z].solutionURL.match(regex)) {
                this.solutionURLFormatInvalid = true;
                return;
              }

              if (this.sub[x].moreSolution[z].videoName == "") {
                this.solutionNameEmpty = true;
                return;
              }
            } else {
              if (this.sub[x].moreSolution[z].solutionDescription == "") {
                this.solutionDescriptionEmpty = true;
                return;
              }
            }
          }
        }
      }
      this.loader = true;
      let topicIds = [this.parentTopic, this.topic, this.subtopic];
      const formdata = new FormData();
      formdata.append("topic_id", this.subtopic);
      formdata.append("question", this.question);
      formdata.append("image", this.questionImage);
      formdata.append("topic_ids", topicIds);

      for (var i = 0; i < this.sub.length; i++) {
        if (this.sub[i].type == "Fillups") {
          formdata.append(
            "group_questions[" + i + "][question_type]",
            "fill_in_blank"
          );
          formdata.append(
            "group_questions[" + i + "][image]",
            this.sub[i].subquestionImage
          );
          formdata.append(
            "group_questions[" + i + "][question]",
            this.sub[i].subQstn
          );
          formdata.append(
            "group_questions[" + i + "][answer]",
            this.sub[i].correctAnswer
          );
          for (var j = 0; j < this.sub[i].moreSolution.length; j++) {
            if (this.sub[i].moreSolution[j].solutionType == "video") {
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][type]",
                "video"
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][video_url]",
                this.sub[i].moreSolution[j].solutionURL
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][video_name]",
                this.sub[i].moreSolution[j].videoName
              );
            } else {
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][type]",
                "description"
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][description]",
                this.sub[i].moreSolution[j].solutionDescription
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][image]",
                this.sub[i].moreSolution[j].solutionImage
              );
            }
          }
        } else {
          formdata.append(
            "group_questions[" + i + "][question_type]",
            "objective"
          );
          formdata.append(
            "group_questions[" + i + "][image]",
            this.sub[i].subquestionImage
          );
          formdata.append(
            "group_questions[" + i + "][question]",
            this.sub[i].subQstn
          );
          formdata.append(
            "group_questions[" + i + "][options][" + 0 + "]",
            this.sub[i].option1
          );
          formdata.append(
            "group_questions[" + i + "][options][" + 1 + "]",
            this.sub[i].option2
          );
          formdata.append(
            "group_questions[" + i + "][options][" + 2 + "]",
            this.sub[i].option3
          );
          formdata.append(
            "group_questions[" + i + "][options][" + 3 + "]",
            this.sub[i].option4
          );
          formdata.append(
            "group_questions[" + i + "][options][" + 4 + "]",
            this.sub[i].option5
          );
          formdata.append(
            "group_questions[" + i + "][answer]",
            this.sub[i].correctAnswer
          );
          for (var l = 0; l < this.sub[i].moreSolution.length; l++) {
            if (this.sub[i].moreSolution[l].solutionType == "video") {
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][type]",
                "video"
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][video_url]",
                this.sub[i].moreSolution[l].solutionURL
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][video_name]",
                this.sub[i].moreSolution[l].videoName
              );
            } else {
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][type]",
                "description"
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][description]",
                this.sub[i].moreSolution[l].solutionDescription
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][image]",
                this.sub[i].moreSolution[l].solutionImage
              );
            }
          }
        }
      }
      await axios
        .post(`${this.$store.getters.baseUrl}/question/group_store`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loader = false;
            this.$swal(
              "Success",
              "Group question added successfully",
              "success"
            );
            this.$router.push({ name: "Tables Questions" });
            (this.parentTopic = ""),
              (this.topic = ""),
              (this.subtopic = ""),
              (this.question = ""),
              (this.questionImage = "");
            (this.sub[0].type = ""),
              (this.sub[0].subquestionImage = ""),
              (this.sub[0].subQstn = ""),
              (this.sub[0].option1 = ""),
              (this.sub[0].option2 = ""),
              (this.sub[0].option3 = ""),
              (this.sub[0].option4 = ""),
              (this.sub[0].option5 = ""),
              (this.sub[0].correctAnswer = ""),
              (this.sub[0].moreSolution = []);
            this.sub.splice(1);
            this.topicEmpty = false;
            this.parentTopicEmpty = false;
            this.subTypeEmpty = false;
            this.questionEmpty = false;
            this.subTypeEmpty = false;
            this.subQstnEmpty = false;
            this.solutionDescriptionEmpty = false;
            this.solutionURLEmpty = false;
            this.option2Empty = false;
            this.option1Empty = false;
            this.solutionNameEmpty = false;
            this.solutionTypeEmpty = false;
            this.correctAnswerEmpty = false;
            this.solutionURLFormatInvalid = false;
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getParentTopics() {
      await axios
        .get(`${this.$store.getters.baseUrl}/topics`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.parentTopics = response.data.topics;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getTopics() {
      this.parentTopicEmpty = false;
      this.topic = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.parentTopic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.topics = response.data.topics;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getSubtopics() {
      this.topicEmpty = false;
      this.subtopic = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.topic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.subtopics = response.data.topics;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    buttonEnable() {
      return this.sub[this.sub.length - 1].correctAnswer;
    },

    appendMoreSolution(index1) {
      this.sub[index1].moreSolution = [
        ...this.sub[index1].moreSolution,
        {
          solutionType: "",
          solutionURL: "",
          solutionDescription: "",
          videoName: "",
          solutionImage: "",
        },
      ];
    },

    appendMoreSubQuestions() {
      this.sub.push({
        type: "",
        subquestionImage: "",
        subQstn: "",
        option1: "",
        option2: "",
        option3: "",
        option4: "",
        option5: "",
        correctAnswer: "",
        moreSolution: [],
      });
    },
  },
  data() {
    return {
      config: {
        toolbar: [
          {
            name: "clipboard",
            groups: ["clipboard", "undo"],
            items: [
              "Cut",
              "Copy",
              "Paste",
              "PasteText",
              "PasteFromWord",
              "-",
              "Undo",
              "Redo",
            ],
          },
          {
            name: "editing",
            groups: ["find", "selection", "spellchecker"],
            items: ["Find", "Replace", "-", "SelectAll", "-", "Scayt"],
          },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
          {
            name: "insert",
            items: [
              "Image",
              "Flash",
              "Table",
              "HorizontalRule",
              "Smiley",
              "SpecialChar",
              "PageBreak",
              "Iframe",
            ],
          },
          { name: "tools", items: ["Maximize", "ShowBlocks"] },
          {
            name: "document",
            groups: ["mode", "document", "doctools"],
            items: ["Source"],
          },
          {
            name: "basicstyles",
            groups: ["basicstyles", "cleanup"],
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
              "-",
              "CopyFormatting",
              "RemoveFormat",
            ],
          },
          "/",
          {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi"],
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
              "CreateDiv",
              "-",
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
              "-",
              "BidiLtr",
              "BidiRtl",
              "Language",
            ],
          },

          { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "others", items: ["-"] },
          { name: "about", items: ["About"] },
          { name: "mathjax", items: ["Mathjax"] },
        ],
        extraPlugins: ["mathjax", "font", "justify"],
        mathJaxLib:
          "//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-AMS_HTML",
      },
      loader: false,
      solutionURLFormatInvalid: false,
      solutionDescriptionEmpty: false,
      solutionTypeEmpty: false,
      solutionNameEmpty: false,
      solutionURLEmpty: false,
      correctAnswerEmpty: false,
      option1Empty: false,
      option2Empty: false,
      subQstnEmpty: false,
      subTypeEmpty: false,
      questionEmpty: false,
      parentTopicEmpty: false,
      topicEmpty: false,
      subtopicEmpty: false,
      parentTopic: "",
      parentTopics: [],
      topic: "",
      topics: [],
      subtopic: "",
      subtopics: [],
      question: "",
      questionImage: [],
      sub: [
        {
          type: "",
          subquestionImage: [],
          subQstn: "",
          option1: "",
          option2: "",
          option3: "",
          option4: "",
          option5: "",
          correctAnswer: "",
          moreSolution: [],
        },
      ],
    };
  },
};
</script>
